var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0V0.75H1.5V1.5H10.5V0.75H8.25V0H3.75Z",
    fill: "#E71E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75V5.25H5.25V9.75H4.5Z",
    fill: "#E71E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.25V9.75H7.5V5.25H6.75Z",
    fill: "#E71E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 2.25V10.5C2.25 11.3284 2.92157 12 3.75 12H8.25C9.07843 12 9.75 11.3284 9.75 10.5V2.25H2.25ZM9 3H3V10.5C3 10.9142 3.33579 11.25 3.75 11.25H8.25C8.66421 11.25 9 10.9142 9 10.5V3Z",
    fill: "#E71E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-delete.60dde3648315fbce69c982914f0fac64.svg";